import React from "react";

export const AdminHeader = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-2">Admin Panel</h1>
      <p className="text-muted-foreground">Manage users and system settings</p>
    </div>
  );
};
